import React, { useState } from 'react';
import { Container, Box, Typography, Grid, Paper, Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PersonIcon from '@mui/icons-material/Person';
import DiamondIcon from '@mui/icons-material/Diamond';
import ShareIcon from '@mui/icons-material/Share';
import Profile from './Profile';
import Favorites from './Favorites';
import Performance from './Performance';
import Links from './Links';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#1a1a1a',
  marginBottom: '2rem',
});

const StatsCard = styled(Paper)({
  padding: '1.5rem',
  backgroundColor: '#fafafa',
  border: '1px solid #eee',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
});

const StatValue = styled(Typography)({
  fontSize: '2rem',
  fontWeight: 'bold',
  color: '#c4a661',
  marginTop: '0.5rem',
});

const StatLabel = styled(Typography)({
  color: '#666',
  marginTop: '0.5rem',
});

const StyledTabs = styled(Tabs)({
  marginBottom: '2rem',
  '& .MuiTab-root': {
    textTransform: 'none',
    fontSize: '1.1rem',
    minWidth: 120,
  },
  '& .Mui-selected': {
    color: '#c4a661',
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#c4a661',
  },
});

const AffiliateDashboard = () => {
  const [currentTab, setCurrentTab] = useState(0);

  // Mock data - replace with real data from backend
  const stats = {
    clicks: 1234,
    sales: 45,
    commission: 2850,
    favorites: 12,
  };

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const renderTabContent = () => {
    switch (currentTab) {
      case 0:
        return <Profile />;
      case 1:
        return <Favorites />;
      case 2:
        return <Performance />;
      case 3:
        return <Links />;
      default:
        return <Profile />;
    }
  };

  return (
    <Container maxWidth="lg">
      <Box sx={{ py: 8 }}>
        <PageTitle>Affiliate Dashboard</PageTitle>

        <Grid container spacing={4} sx={{ mb: 6 }}>
          <Grid item xs={12} sm={6} md={3}>
            <StatsCard elevation={0}>
              <MonetizationOnIcon sx={{ fontSize: 40, color: '#c4a661' }} />
              <StatValue>${stats.commission}</StatValue>
              <StatLabel>Total Commission</StatLabel>
            </StatsCard>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <StatsCard elevation={0}>
              <ShareIcon sx={{ fontSize: 40, color: '#c4a661' }} />
              <StatValue>{stats.clicks}</StatValue>
              <StatLabel>Total Clicks</StatLabel>
            </StatsCard>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <StatsCard elevation={0}>
              <MonetizationOnIcon sx={{ fontSize: 40, color: '#c4a661' }} />
              <StatValue>{stats.sales}</StatValue>
              <StatLabel>Total Sales</StatLabel>
            </StatsCard>
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <StatsCard elevation={0}>
              <DiamondIcon sx={{ fontSize: 40, color: '#c4a661' }} />
              <StatValue>{stats.favorites}</StatValue>
              <StatLabel>Favorite Items</StatLabel>
            </StatsCard>
          </Grid>
        </Grid>

        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <StyledTabs value={currentTab} onChange={handleTabChange}>
            <Tab icon={<PersonIcon />} label="Profile" />
            <Tab icon={<DiamondIcon />} label="Favorites" />
            <Tab icon={<MonetizationOnIcon />} label="Performance" />
            <Tab icon={<ShareIcon />} label="Links" />
          </StyledTabs>
        </Box>

        {renderTabContent()}
      </Box>
    </Container>
  );
};

export default AffiliateDashboard;
